import { z } from "zod";

export const zClsNode = z.object({
  id: z.string(),
  name: z.string(),
  hasChildren: z.boolean(),
  childrenCount: z.number().nullish(),
});

export type ZClsNode = z.infer<typeof zClsNode>;
